import CutwiseAPIClient, { METHOD_GET } from '@/common/network/CutwiseAPIClient';
export const PATH_MODELS_SPECTRUM = 'api/models/spectrum';
export default class SpectrumAPI {
    fetchModels(ids, dns) {
        const qb = CutwiseAPIClient.createQueryBuilder()
            .method(METHOD_GET)
            .path(PATH_MODELS_SPECTRUM)
            .addQueryStringParam('id', ids)
            .addQueryStringParam('dn', dns)
            .suppressErrorNotifications();
        return CutwiseAPIClient.sendQuery(qb.getQuery());
    }
}
